import { useEffect, useState } from "react";
import Footer from "../components/footer";
import { Navbar } from "../components/navbar";
import { Sidebar } from "../components/sidebar";
import { styled } from "styled-components";
import useAuth from "../auth/useAuth";
import { animateScroll } from "react-scroll";
import invoicesApi from "../api/user/invoices";
import Spinner from "../components/spinner";

const Invoices = () => {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [payload, setPayload] = useState({
    invoices: [],
    loading: true,
  });

  useEffect(() => {
    animateScroll.scrollToTop();

    invoicesApi
      .getMyInvoices()
      .then((res) => {
        const { invoices } = res.data;
        setPayload({
          ...payload,
          invoices,
          loading: false,
        });
      })
      .catch((err) => {
        setPayload({
          ...payload,
          loading: false,
        });
      });
  }, []);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Container>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />

      <ContentContainer>
        <TopContainer>
          <AvatarContainer>
            <AvatarImage src={user.avatarURL || "/images/default-user.jpg"} />
            <UserName>{user.name}</UserName>
          </AvatarContainer>
        </TopContainer>

        <InvoicesContainer>
          <InputsTitle>Invoices</InputsTitle>

          {payload.loading ? (
            <SpinnerContainer>
              <Spinner size="small" />
            </SpinnerContainer>
          ) : payload.invoices.length ? (
            payload.invoices.map((invoice) => (
              <InvoiceContainer id={invoice._id}>
                <RowContainer>
                  <RowTitle>Service:</RowTitle>
                  <RowValue>{invoice.service.title}</RowValue>
                </RowContainer>

                <RowContainer>
                  <RowTitle>Paid:</RowTitle>
                  <RowValue>{invoice.paid ? "Paid" : "Unpaid"}</RowValue>
                </RowContainer>

                {invoice.paid && (
                  <RowContainer>
                    <RowTitle>Paid on:</RowTitle>
                    <RowValue>
                      {new Date(invoice.paidAt).toLocaleString()}
                    </RowValue>
                  </RowContainer>
                )}

                <RowContainer>
                  <RowTitle>Price:</RowTitle>
                  <RowValue>£{invoice.amount}</RowValue>
                </RowContainer>

                <RowContainer>
                  <RowTitle>Type:</RowTitle>
                  <RowValue>{invoice.service.type}</RowValue>
                </RowContainer>

                <RowContainer>
                  <RowTitle>App ID:</RowTitle>
                  <RowValue>{invoice.service.url || "Not provided"}</RowValue>
                </RowContainer>

                <RowContainer>
                  <RowTitle>Date:</RowTitle>
                  <RowValue>
                    {new Date(invoice.createdAt).toLocaleString()}
                  </RowValue>
                </RowContainer>
              </InvoiceContainer>
            ))
          ) : (
            <NoInvoicesMessage>You have no invoices yet.</NoInvoicesMessage>
          )}
        </InvoicesContainer>
      </ContentContainer>

      <Footer />
    </Container>
  );
};

const Container = styled.div`
  background-color: #000;
`;

const ContentContainer = styled.main`
  margin-top: 80px;
  padding: 50px 80px;
  background-color: #fefefe;
  display: flex;
  gap: 45px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const TopContainer = styled.div`
  display: flex;
  justify-content: center;
`;

const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const AvatarImage = styled.img`
  border-radius: 50%;
  width: 100px;
  object-fit: cover;
  cursor: pointer;
`;

const UserName = styled.h1`
  font-size: 15px;
  font-weight: 600;
`;

const InvoicesContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  width: 80vw;
  max-width: 400px;
`;

const InputsTitle = styled.h2`
  font-weight: bold;
  text-transform: capitalize;
`;

const SpinnerContainer = styled.div`
  margin-top: 1rem;
  margin-left: 1rem;
`;

const NoInvoicesMessage = styled.p`
  font-size: 14px;
  font-weight: 600;
`;

const InvoiceContainer = styled.div`
  border: 2px solid #ff6341;
  border-radius: 8px;
  padding: 0.25rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RowTitle = styled.p`
  font-weight: 700;
  font-size: 15px;
  color: #ff6341;
  margin: 0;
`;

const RowValue = styled.p`
  font-size: 14px;
  margin: 0;
  font-weight: 600;
`;

export default Invoices;
